module.exports = __webpack_public_path__ + "static/media/Hour_01-06.33b7ba3b.png";